export interface ListValue {
  id: number;
  value: string;
  canBeDeleted: boolean;
}
